import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardHeader, CardTitle, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import {
  Users,
  Puzzle,
  Brain,
  LineChart,
  Megaphone,
  AlertCircle,
  Gem,
  Briefcase,
  Rocket,
  CheckCircle,
} from "lucide-react";

const Register = () => {
  const { t } = useTranslation();

  const roles = [
    {
      key: "participant",
      icon: Users,
      formLink:
        "https://docs.google.com/forms/d/e/1FAIpQLSfXq4iFWUylF0DOCUbU2kB3QsqfZMOmZYCMl6_RQefdIpXIow/viewform?usp=header",
    },
    {
      key: "entrepreneur",
      icon: Rocket,
      formLink:
        "https://docs.google.com/forms/d/e/1FAIpQLScCDDe2vyUv8XpkCV4FAfsb-rijKCqhOYhFz9s6bHsdAQFwSg/viewform?usp=header",
    },
    {
      key: "investor",
      icon: Briefcase,
      formLink:
        "https://docs.google.com/forms/d/e/1FAIpQLSdk3g2fCK2r4iP6dhoo6wXTBzaaBjLGLRNihlRvV1Kzd7tdzw/viewform?usp=header",
    },
  ];

  const criteria = [
    { label: t("register.pitch.criteria.mvp"), icon: Puzzle },
    { label: t("register.pitch.criteria.realism"), icon: Brain },
    { label: t("register.pitch.criteria.fin"), icon: LineChart },
    { label: t("register.pitch.criteria.pitching"), icon: Megaphone },
    { label: t("register.pitch.criteria.problem"), icon: AlertCircle },
    { label: t("register.pitch.criteria.novelty"), icon: Gem },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-20 px-6 lg:px-8">
      {/* Заголовок */}
      <div className="max-w-6xl mx-auto text-center mb-16">
        <h1 className="text-4xl font-bold mb-4">{t("register.title")}</h1>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          {t("register.subtitle")}
        </p>
      </div>

      {/* Карточки ролей */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-20">
        {roles.map((role, index) => (
          <Card
            key={index}
            className="shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300 flex flex-col"
          >
            <CardHeader className="flex flex-col items-center">
              <role.icon className="h-12 w-12 text-yellow-500 mb-4" />
              <CardTitle className="text-2xl font-bold">
                {t(`register.role.${role.key}.title`)}
              </CardTitle>
            </CardHeader>
            <CardContent className="flex-1 flex flex-col justify-between">
              <div>
                <p className="text-gray-600 mb-6 text-center">
                  {t(`register.role.${role.key}.description`)}
                </p>
                <ul className="space-y-3 text-left">
                  {t(`register.role.${role.key}.privileges`, {
                    returnObjects: true,
                  }).map((priv, i) => (
                    <li key={i} className="flex items-center text-gray-700">
                      <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                      {priv}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-6 text-center">
                <Button
                  asChild
                  className="bg-yellow-500 hover:bg-yellow-400 text-black font-semibold px-6 py-3 rounded-full transition-all duration-300 hover:scale-105"
                >
                  <a
                    href={role.formLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("register.apply")}
                  </a>
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Criteria Section */}
      <section className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
        {/* Левая часть */}
        <div>
          <h2 className="text-4xl font-bold text-black mb-6">
            {t("register.pitch.title")}
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            {t("register.pitch.subtitle")}
          </p>
        </div>

        {/* Правая часть */}
        <div className="grid grid-cols-2 gap-8">
          {criteria.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center"
            >
              <div className="p-4 bg-yellow-100 rounded-full mb-3">
                <item.icon className="h-8 w-8 text-black" />
              </div>
              <p className="font-semibold text-black">{item.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Investor Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                    {/* Картинка */}
          <div className="order-2 md:order-1 flex justify-center">
            <img
              src="/investor.png"
              alt="Investor illustration"
              className="w-full max-w-md rounded-xl shadow-lg object-contain"
            />
          </div>
          {/* Текст */}
          <div className="order-2 md:order-1">
            <h2 className="text-4xl font-bold text-black mb-6">
              {t('register.investor.title')}
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-4">
              {t('register.investor.subtitle')}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t('register.investor.subsubtitle')}
            </p>
          </div>


        </div>
      </section>
    </div>
  );
};

export default Register;
